import styled, { css } from 'styled-components';

export const Card = styled.div`
  border-bottom: 1px ${({ theme }) => theme.colorsInObjects.gray[600]} solid;
  padding-bottom: ${({ theme }) => theme.spacing.m};
  margin: ${({ theme }) => theme.spacing.m};
  margin-top: 0;
`;

export const Tag = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dimGray};
  border-radius: ${({ theme }) => theme.radius.xs};
  padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.s}`};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  border: 1px #f1f1f1 solid;
  width: fit-content;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
`;

export const Question = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const IconSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const ButtonWithIcon = styled.button(
  ({ theme, borderColor, backgroundColor = 'white' }) => css`
    border: 1px solid ${theme.colors[borderColor] || backgroundColor};
    border-radius: ${theme.radius.xs};
    background-color: ${theme.colors[backgroundColor] || backgroundColor};
    height: ${theme.spacing.xl};
    width: ${theme.spacing.xl};
    display: flex;
    justify-content: center;
    align-items: center;
  `
);

export const TextAreaContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
  display: flex;
  flex-direction: column;
`;

export const TagSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DropdownButton = styled.button`
  background-color: transparent;
  border: none;
  padding-right: 0;
`;

export const ImageInputContainer = styled.input`
  display: none;
`;

export const ButtonWrapper = styled.div`
  margin: 16px;
`;

export const DeleteTitleContainer = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.fontSize.xxl};
`;

export const DeleteMessageContainer = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.fontSize.m};
  margin-bottom: ${({ theme }) => theme.fontSize.m};
`;

export const ImageButtonContainer = styled.div``;
